import { vaciarBaseLocal } from './db.js'

/**
 * La sesion. Es la **unica** excepcion a "la UI no toca la red" junto con el
 * sincronizador, y por una razon concreta: el login ocurre antes de que exista
 * base local que leer.
 *
 * La cookie es httpOnly, asi que el token no se toca desde JS: lo unico que se
 * guarda aca es quien sos, para pintar la UI correcta.
 */

const BASE = '/api'

export interface Sesion {
  usuario: { id: string; email: string; nombre: string }
  tenant: { id: string; nombre: string }
  rol: 'admin' | 'recepcion' | 'profesional'
  recursoPersonaId: string | null
  flags: string[]
}

export async function login(email: string, clave: string, tenantId?: string): Promise<Sesion> {
  const res = await fetch(`${BASE}/auth/login`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(tenantId ? { email, clave, tenantId } : { email, clave }),
  })

  if (res.status === 409) {
    const cuerpo = (await res.json()) as { tenants: { id: string; nombre: string }[] }
    throw new ErrorVariosTenants(cuerpo.tenants)
  }
  if (!res.ok) {
    const cuerpo = (await res.json().catch(() => ({}))) as { mensaje?: string }
    throw new Error(cuerpo.mensaje ?? 'No pudimos iniciar sesión')
  }

  return quienSoy()
}

export class ErrorVariosTenants extends Error {
  constructor(readonly tenants: { id: string; nombre: string }[]) {
    super('El usuario tiene varias clínicas')
    this.name = 'ErrorVariosTenants'
  }
}

export async function quienSoy(): Promise<Sesion> {
  const res = await fetch(`${BASE}/auth/yo`, { credentials: 'include' })
  if (!res.ok) throw new Error('Sesión no válida')
  return (await res.json()) as Sesion
}

export async function logout(): Promise<void> {
  await fetch(`${BASE}/auth/logout`, { method: 'POST', credentials: 'include' })
  // Dejar la agenda de una clinica en el dispositivo despues de cerrar sesion
  // es una fuga, aunque sea el mismo navegador.
  await vaciarBaseLocal()
}
